import React from 'react';
import PropTypes from 'prop-types';
import {Segment} from 'semantic-ui-react';
import {isEmpty as _isEmpty} from 'lodash';

import SegmentHeader from '@appComponents/SegmentHeader';
import {ReportButtons} from '@modules/events/views/ReportButtons';
import {ReportTable} from '@modules/events/components/EventsReport/ReportTable';
import {ReportsCoverageMessage} from '@modules/events/views/ReportsCoverageMessage';
import {ReportsDurationMessage} from '@modules/events/views/ReportsDurationMessage';
import {INCIDENT_DURATION_UNIT_MINUTE} from '@constants/variables';

export const Reports = ({eventId, buttonData, loading, reportsData, duration, match}) => {
    const hasReportableProducts = buttonData?.hasReportableProducts ?? false;
    const minuteIncidentReports = reportsData?.filter(
        report => INCIDENT_DURATION_UNIT_MINUTE === report.incident_duration_unit?.id
    ) || [];

    return (
        <>
            <SegmentHeader
                buttons={<ReportButtons eventId={eventId} buttonData={buttonData}/>}
            >
                Reports
            </SegmentHeader>
            <Segment basic className='--table'>
                {hasReportableProducts ? (
                    <>
                        <ReportsCoverageMessage
                            hasNoIncludesAllStreamsReport={buttonData.hasNoIncludesAllStreamsReport}
                            hasUncoveredCombinations={buttonData.hasUncoveredCombinations}
                            hasEventDurationInfo={buttonData.hasEventDurationInfo}
                        />
                        {!_isEmpty(minuteIncidentReports)
                            && (
                                <ReportsDurationMessage
                                    duration={duration}
                                    match={match}
                                    minuteIncidentReports={minuteIncidentReports}
                                />
                            )}
                        <ReportTable eventId={eventId} loading={loading} reportsData={reportsData}/>
                    </>
                ) : (
                    <p>This event does not contain any reportable distribution.</p>
                )}
            </Segment>
        </>
    );
};

Reports.propTypes = {
    eventId: PropTypes.number.isRequired,
    data: PropTypes.object,
    buttonData: PropTypes.object,
    loading: PropTypes.bool,
    reportsData: PropTypes.array,
    duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    match: PropTypes.object,
};
